import {sortBy} from 'lodash'
import Fuse from 'fuse.js'

let data = null;

export async function init() {
    if(!data) {
        data = await fetchData();
    }
}

function fetchData() {
    return fetch('/api/bonuswelt').then(response => response.json())
}


export function getOfferById(id) {
    if(!data) {
        return null;
    }

    const offers = data.offers.changed;
    const offer = offers.find(offer => {
        return offer.id === id
    })
    if( !offer ) {
        return null;
    }
    offer.company = getCompanyById(offer.companyId)
    offer.companyLocation = getCompanyLocationById(offer.companyId)
    return offer
}

function getCompanyById(id) {
    if(!data) {
        return null;
    }
    const companies = data.companies.changed;
    return companies.find(company => {
        return company.id === id
    })
}

function getCompanyLocationById(id) {
    if(!data) {
        return null;
    }
    const locations = data.companyLocations.changed;
    return locations.find(location => {
        return location.companyId === id
    })
}

export function getSortedOffers() {
    if(!data) {
        return [];
    }
    return data.offerOrder.map(getOfferById);
}

export function getCategories() {
    if(!data) {
        return [];
    }
    const defaultCategory = {'id': 0, 'name': 'Alles'}
    return [defaultCategory].concat(data.categories.changed);
}

export function search(offers, searchTerm) {
    if(!offers) {
        return [];
    }
    const fuse = new Fuse(offers, {
        shouldSort: true,
        includeScore: true,
        threshold: 0.2,
        location: 0,
        distance: 100,
        minMatchCharLength: 1,
        keys: [
            'company.name',
            'description'
        ]
    });

    const fuseSearch = fuse.search(searchTerm)
    return fuseSearch.map(e => e.item);
}


export function filterByCategory(offers, category) {
    if(!offers) {
        return [];
    }
    const filteredOffers = offers.filter(offer => {
        return offer.categoryId === category
    })
    return category === 0 ? offers : filteredOffers
}

export function filterOffers(offers, filterOption) {
    if(!offers) {
        return [];
    }
    const filteredOffers = offers.filter(offer => {
        return offer.profitType === filterOption
    })
    return filterOption === 'all' ? offers : filteredOffers
}

export function sortOffersBy(offers, sortTerm) {
    if(!offers || !data) {
        return [];
    }
    switch (sortTerm) {
        case 'popular':
            return data.offerOrder.map((id) => {
                return offers.find(offer => {
                    return offer.id === id
                })
            }).filter(i => !!i)
        case 'neueste':
            return sortBy(offers, ['id']);
        case 'alphabetisch':
            return sortBy(offers, (offer) => {
                return offer.company.name
            });
    }
}

export function setSearchParams(param, value, urlSearchParams) {
    if (urlSearchParams.get(param)) {
        urlSearchParams.set(param, value);
    } else {
        urlSearchParams.append(param, value);
    }
    return urlSearchParams
}



